import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/** Branded empty state with the blue botanical illustration. */
export function EmptyState({
  title,
  description,
  action,
  className,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex flex-col items-center rounded-lg border border-border border-dashed bg-card/60 px-6 py-14 text-center",
        className,
      )}
    >
      <img src="/assets/bouquet.svg" alt="" aria-hidden className="mb-4 h-20 w-auto opacity-90" />
      <h3 className="font-semibold text-foreground text-lg">{title}</h3>
      {description ? (
        <p className="mt-1 max-w-sm text-muted-foreground text-sm">{description}</p>
      ) : null}
      {action ? <div className="mt-5">{action}</div> : null}
    </div>
  );
}
